<template>
  <div class="new-content new-content_event">
    <TextareaAutosize
      class="new-title"
      type="text"
      v-model="title"
      placeholder="Ищу пару спортивных девушек..."
      maxlength="110"
    />
    <block
      v-for="(block, index) in blocks"
      :key="'block-' + index"
      :placeholder="'Опиши все важные детали ивента'"
      :block="block"
      :index="index"
      :navigation="blocks.length > 1"
      :addMore="addMoreImages"
      @click="deleteBlock(index)"
      @changeType="changeType"
      @changeValue="changeValue"
      @deleteBlock="deleteBlock"
      @moveUp="moveUpBlock"
      @moveDown="moveDownBlock"
    />
    <div class="new-block new-block_adder" v-if="addMoreBlocks">
      <div class="new-block-type visible">
        <div class="new-block-type__item active" @click="blocks.push({ type: 'paragraph', value: '' })">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#2E3A59"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              d="M5 6.41L10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41 17.59 5 12 10.59 6.41 5 5 6.41z"
            />
          </svg>
        </div>
        <div class="new-block-type__item" @click="blocks.push({ type: 'paragraph', value: '' })">
          <svg xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 24 24">
            <path d="M15 19H3v-2h12v2zm6-4H3v-2h18v2zm-6-4H3V9h12v2zm6-4H3V5h18v2z" />
          </svg>
        </div>
        <div class="new-block-type__item" @click="blocks.push({ type: 'image', value: [] })" v-if="addMoreImages">
          <svg xmlns="http://www.w3.org/2000/svg" fill="#2E3A59" viewBox="0 0 24 24">
            <path
              d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2zM5 5v14h14V5H5zm13 12H6l3-4 1 1 3-4 5 7zm-9.5-6a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
            />
          </svg>
        </div>
        <div
        class="new-block-type__item"
        @click="blocks.push({ type: 'h3', value: '' })"
      >
        <p>H</p>
      </div>
      <div
        class="new-block-type__item"
        @click="blocks.push({ type: 'youtube', value: '' })"
      >
        <p>Y</p>
        
      </div>
      </div>
    </div>
    <!-- Категории спорта -->
    <div class="new-string">
      <!-- <h3 class="new-subtitle">Выберите категории спорта</h3> -->
      <div class="new-sports">
        <div class="map-button map-button_rainbow" @click="changeState('sports_new')">
          <p>Выберите виды спорта</p>
        </div>

        <Sports :sports="getActiveSports" />
      </div>
    </div>
    <block-place @setPlace="setPlace" @setPosition="setPosition" />
    <div class="chat-users" v-if="getNewInvites">
      <div
        @click="openUser(user.id)"
        v-for="user in getNewInvites"
        :key="user.id"
        :user="user"
        class="chat-users__user"
        :style="{ backgroundImage: 'url(' + user.avatar + ')' }"
        :title="user.firstname + ' ' + user.lastname"
      >
      </div>
      <div
        class="chat-users__add"
        @click="$store.dispatch('changeState', { element: 'invite_new' })"
      >
        <p v-if="getNewInvites.length < 1">Пригласить людей</p>
        <img v-else src="@/assets/images/icons/icon_plus.svg" alt="" />
      </div>
    </div>
    <!-- Даты -->
    <div class="new-filters">
      <div class="new-filters__dates">
        <div class="new-filters__item new-filters__item_date">
          <div class="clear-time" v-if="!start">
            <font-awesome-icon icon="cloud-sun" style="font-size: 34px" />
            <p>Время начала</p>
          </div>
          <div class="has-time" v-if="start">
            <font-awesome-icon icon="cloud-sun" style="font-size: 20px" />
            <p class="has-time__big">{{ getTime(start) }}</p>
            <p class="has-time__small">{{ getDate(start) }}</p>
          </div>
          <datetime v-model="start" :type="'datetime'" :placeholder="'Время начала'" />
        </div>
        <div class="new-filters__item new-filters__item_date">
          <div class="clear-time" v-if="!end">
            <font-awesome-icon icon="moon" style="font-size: 34px" />
            <p>Время завершения</p>
          </div>
          <div class="has-time" v-if="end">
            <font-awesome-icon icon="moon" style="font-size: 20px" />
            <p class="has-time__big">{{ getTime(end) }}</p>
            <p class="has-time__small">{{ getDate(end) }}</p>
          </div>
          <datetime v-model="end" :type="'datetime'" :placeholder="'Время завершения'" />
        </div>
      </div>
      <div class="new-filters__item new-filters__item_input">
        <p>Макс. участников:</p>
        <input class="input" placeholder="10" type="text" v-model="options.max" />
      </div>
      <div class="new-filters__checkbox">
        <input id="photo" class="checkbox" type="checkbox" v-model="options.photo" />
        <label for="photo">Запретить участникам добавлять фото</label>
      </div>
      <div class="new-filters__checkbox">
        <input id="users" class="checkbox" type="checkbox" v-model="options.users" />
        <label for="users">Запретить участникам добавлять участников</label>
      </div>
      <!-- <div class="new-filters__checkbox">
        <input id="public" class="checkbox" type="checkbox" v-model="options.public" />
        <label for="public">Закрытое мероприятие</label>
      </div> -->
      <div class="new-filters__checkbox">
        <input id="chat" class="checkbox" type="checkbox" v-model="options.chat" />
        <label for="chat">Создать чат события</label>
      </div>
      <!-- <div class="new-filters__checkbox">
        <input id="cover" class="checkbox" type="checkbox" v-model="options.cover" />
        <label for="cover">Не показывать обложку в списке мероприятий</label>
      </div> -->
    </div>
    <block-cover @changeCover="changeCover" :path="'covers'"/>
    <div class="new-footer">
      <div class="new-publish" :class="{loading: 'load'}" @click="publish()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="white"
          viewBox="0 0 24 24"
          v-if="!loading"
        >
          <path
            d="M9.525 17.657l-4.95-4.95 1.414-1.414 3.537 3.534-.001.001 8.485-8.485 1.414 1.414-8.485 8.486-1.413 1.413-.001.001z"
          />
        </svg>
        <p v-if="!loading">Опубликовать</p>
        <svg v-else class="new-publish-loader" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
            <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
              <animateTransform 
                attributeName="transform" 
                attributeType="XML" 
                type="rotate"
                dur="1s" 
                from="0 50 50"
                to="360 50 50" 
                repeatCount="indefinite" />
          </path>
        </svg>
      </div>
    </div>
    <ModalAddUser />
    <SportsWindowNew v-if="showSports" />
  </div>
</template>
<script>
import { Datetime } from 'vue-datetime';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCloudSun, faMoon
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faCloudSun,
  faMoon
);

export default {
  name: 'NewEvent',
  components: {
    Datetime,
    Block: () => import('./Block'),
    SportsWindowNew: () => import('@/components/Filters/SportsWindowNew'),
    ModalAddUser: () => import('@/components/Modals/ModalNewAddUser'),
    Sports: () => import('@/components/Filters/SportsNew'),
    BlockPlace: () => import('./BlockPlace'),
    BlockCover: () => import('./BlockCover')
  },
  data: () => {
    return {
      title: null,
      blocks: [
        {
          type: 'paragraph',
          value: null,
        },
      ],
      place: null,
      start: null,
      end: null,
      users: [],
      options: {
        photos: true,
        private: true,
        chat: true,
        cover: true,
        users: false,
        max: 10,
      },
      cover: null,
      text: null,
      position: null,
      region: null,
      sports_forget: true,
      loading: false
    };
  },
  computed: {
    showSports () {
			return this.$store.getters.sports_new;
    },
    getActiveSports() {
      return this.$store.getters.getActiveSportsNew;
    },
    getUser() {
      return this.$store.getters.getAuthUser;
    },
    getNewInvites() {
      return this.$store.getters.getNewInvites
    },
    addMoreBlocks() {
      return this.blocks.length < 13
    },
    addMoreImages() {
      let sum = 0;
      this.blocks.forEach(block => {
        block.type == 'image' ? sum += block.value.length : ''; 
      })
      return sum < 6
    }
  },
  methods: {
    getTime(time) {
      return this.$moment(time).format('HH:mm')
    },
    getDate(time) {
      return this.$moment(time).format('DD.MM.YYYY')
    },
    moveUpBlock(index) {
      if (index > 0) {
        let blocks = this.blocks; 
        let block = blocks[index];
        blocks[index] = blocks[index - 1];
        blocks[index - 1] = block;
        this.blocks = [].concat(blocks)
      }
    },
    moveDownBlock(index) {
      if (index < this.blocks.length - 1) {
        let blocks = this.blocks;
        let block = blocks[index];
        blocks[index] = blocks[index + 1];
        blocks[index + 1] = block;
        this.blocks = [].concat(blocks)
      }
    },
    changeType(data) {
      this.blocks[data.index].type = data.type;
      this.blocks[data.index].value = data.type === 'image' ? [] : '';
    },
    changeValue(data) {
      this.blocks[data.index].value = data.value;
    },
    deleteBlock(data) {
      this.$delete(this.blocks, data);
    },
    async publish() {
      let data = {
        type: 'event',
        title: this.title,
        content: this.blocks,
        place: this.place,
        start: this.start,
        end: this.end,
        invites: this.getNewInvites,
        options: this.options,
        author: this.getUser,
        position: this.position,
        sports: this.getActiveSports,
        cover: this.cover,
        country: this.country,
        region: this.region
      };

      let sum_content = Number();
      data.content.forEach((element) => {
        sum_content += element.value.length;
      });

      if (!data.title) {
        this.$store.dispatch('addError', { message: 'Не введено название ивента' });
      } else if (sum_content === 0) {
        this.$store.dispatch('addError', { message: 'Вы не заполнили поле контента' });
      // } else if (!data.place && !data.position) {
      //   this.$store.dispatch('addError', {
      //     message: 'Выберите из имеющихся мест или поставьте точку на карте',
      //   });
      } else if (!data.start) {
        this.$store.dispatch('addError', { message: 'Выберите время начала' });
      } else if (!data.cover) {
        this.$store.dispatch('addError', { message: 'Добавьте обложку' });
      } else if (!data.end) {
        this.$store.dispatch('addError', { message: 'Выберите плановое время окончания' });
      } else if (data.sports.length < 1 && !this.sports_forget) {
        this.sports_forget = false
        this.$store.dispatch('addNotification', { message: 'Не забыли добавить категории спорта?' });
      } else if (!data.author) {
        this.$store.dispatch('addError', { message: 'Ошибка аутентификации' });
      } else if (this.$moment(data.start) >= this.$moment(data.end)) {
        this.$store.dispatch('addError', { message: 'Время начала не может быть позднее времени завершения! 😅' });
      } else if (this.$moment(data.end) < this.$moment()) {
        this.$store.dispatch('addError', { message: 'Время завершения не может быть в прошлом! 😅' });
      } else {
        this.loading = true;
        if (data.place && this.region) {
          this.createEvent(data)
        } else {
          // TODO: переписать на 1 роут
          this.$axios.post('/api/zones/by_coords', {coords: data.position})
            .then( res => {
              data.region = {
                country: res.data.country,
                state: res.data.state,
                country_code: res.data.country_code, 
                state_code: res.data.state_code
              };
              this.createEvent(data)
            })
        }
      }
    },

    async createEvent(data) {
      let event = await this.$store.dispatch('createEvent', data);
      if (event.score) {
        this.$store.dispatch('addScore', event.score)
      }
      this.loading = false;
      this.$router.push({ name: 'event', params: { hash: event.id + '&' + event.hash } });
      this.$store.dispatch('addNotification', { message: 'Ваше мероприятие создано! 😎' });
      this.$store.dispatch('changeState', { element: 'workplace' });
      this.clearData()
    },
    
    changeState(element) {
      this.$store.dispatch('changeState', { element: element, val: true });
    },
    changeCover(cover) {
      this.cover = cover;
    },
    setPlace(place) {
      this.place = place ? place.id : place;
      this.region = place && place.state ? {
        country: place.country,
        state: place.state,
        country_code: place.country_code, 
        state_code: place.state_code 
      } : null;
    },
    setPosition(position) {
      this.position = position;
    },
    clearData() {
      this.$store.dispatch('clearNewInvites')
      this.title = null,
      this.sports_forget = true,
      this.blocks = [
        {
          type: 'paragraph',
          value: null,
        },
      ],
      this.place = null,
      this.start = null,
      this.end = null,
      this.options = {
        photos: true,
        private: true,
        chat: true,
        cover: true,
        users: false,
        max: 10
      },
      this.text = null,
      this.position = null
    }
  },
};
</script>
